import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

    private _config: Config = new Config();

    constructor(private http: HttpClient) { }

    /**
     *
     * @param filtros
     * @param page
     * @param perPage
     */
    public listarMapeamentosPorMunicipio(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any>  {
        perPage = perPage == undefined ? '' : perPage;
        let params = new HttpParams();
        params = params.append('page', page.toString());
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/listar${perPage != null ? '/' + perPage : ''}`, filtros, {params: params});
    }

    /**
     *
     * @param filtros
     * @param page
     * @param perPage
     */
     public listarArquivosPorEmpresa(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any>  {
        perPage = perPage == undefined ? '' : perPage;
        let params = new HttpParams();
        params = params.append('page', page.toString());
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/listarArquivosPorEmpresa${perPage != null ? '/' + perPage : ''}`, filtros, {params: params});
    }

    public qtdArquivosPendentePorData(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any>  {
        perPage = perPage == undefined ? '' : perPage;
        let params = new HttpParams();
        params = params.append('page', page.toString());

        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/qtdarquivospendentespordata${perPage != null ? '/' + perPage : ''}`, filtros, {params: params});
    }

    public totalMapeamentosRealizados(): Observable<any>  {
        return this.http.get<any>(`${this._config.get('urlServiceBackend')}relatorio/totalmapeamentosrealizados`);
    }

    public totalMapeamentosDiarios(filtros: object = null): Observable<any>  {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/totalmapeamentosdiario`, filtros);
    }

    public totalMapeamentosAtualizacaoDiarios(filtros: object = null): Observable<any>  {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/totalmapeamentosatualizacaodiario`, filtros);
    }

    public totalMapeamentosDiariosListaMunicipios(filtros: object = null): Observable<any>  {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/totalmapeamentosdiariolistamunicipios`, filtros);
    }

    public totalMapeamentosAtualizacaoDiariosListaMunicipios(filtros: object = null): Observable<any>  {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}relatorio/totalmapeamentosatualizacaodiariolistamunicipios`, filtros);
    }


}
